import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import ConfirmDialog from "../../layouts/confirmDialog/confirmDialog.vue";
import MailingContractorCarrierContactPersonRestModel from "../../models/rest/mailing/mailingContractorCarrierContactPersonRestModel";
import MailingContractorCarrierDataRestModel from "../../models/rest/mailing/mailingContractorCarrierDataRestModel";
import MailingContractorCarrierFormRestModel from "../../models/rest/mailing/mailingContractorCarrierFormRestModel";
import MailingContractorCarrierVehicleDetailRestModel from "../../models/rest/mailing/mailingContractorCarrierVehicleDetailRestModel";
import CountryRestModel from "../../models/rest/register/countryRestModel";

@Component({
    components: {
        "confirm-dialog": ConfirmDialog,
    }
})

export default class MailingListCarrierDetails extends Vue {
    contactPersonItemsLengthError = null as string | null;
    vehicleDetailsItemsLengthError = null as string | null;
    contactPersonEmailError = null as string | null;
    vehicleTypeIdError = null as string | null;
    vehicleQuantityError = null as string | null;
    servedCountriesError = null as string | null;

    vehicleHeaders = [
        { text: this.$t("mailing.vehicleType"), value: "mailingVehicleTypeId", width: "20%" },
        { text: this.$t("mailing.quantity"), value: "quantity", width: "10%" },
        { text: this.$t("mailing.adr"), value: "adr" },
        { text: this.$t("mailing.tailLift"), value: "lift" },
        { text: this.$t("mailing.openRoof"), value: "openRoof" },
        { text: this.$t("mailing.frigo"), value: "frigo" },
        { text: this.$t("mailing.additionalInfo"), value: "additionalInfo" },
        { text: "", value: "actions", sortable: false }
    ];

    contactPersonsHeaders = [
        { text: this.$t("mailing.firstName"), value: "firstName" },
        { text: this.$t("mailing.lastName"), value: "lastName" },
        { text: this.$t("mailing.position"), value: "position" },
        { text: this.$t("mailing.phone"), value: "telephone" },
        { text: this.$t("mailing.email"), value: "email" },
        { text: "", value: "actions", sortable: false }
    ];

    get validationError(): any {
        return this.$store.direct.state.mailing.mailingContractorCarrierFormErrorValidationError;
    }

    set validationError(val: any) {
        this.$store.direct.commit.mailing.setMailingContractorCarrierFormErrorValidationError(val);
    }

    get mailingFormData(): MailingContractorCarrierFormRestModel {
        return this.$store.direct.state.mailing.mailingContractorCarrierFormData;
    }

    get contractorCarrierData(): MailingContractorCarrierDataRestModel {
        return this.mailingFormData.contractorCarrierData;
    }

    get contactPersons(): MailingContractorCarrierContactPersonRestModel[] {
        return this.mailingFormData.contactPersons;
    }

    get vehicles(): MailingContractorCarrierVehicleDetailRestModel[] {
        return this.mailingFormData.vehicleDetails || [];
    }

    get allCountries(): CountryRestModel[] {
        return this.$store.direct.state.mailing.allCountries;
    }

    get mailingVehicleTypes() {
        return this.$store.direct.state.mailing.mailingVehicleTypes;
    }

    get loading(): boolean {
        return this.$store.direct.state.mailing.loading;
    }


    @Watch("validationError.ContactPersons")
    async validationErrorContactPersonItemsHandler(val: any) {
        if (this.validationError.ContactPersons == undefined) {
            this.contactPersonItemsLengthError = null;
        }
        else {
            this.contactPersonItemsLengthError = this.validationError.ContactPersons[0];
            setTimeout(() => {
                this.contactPersonItemsLengthError = null;
            }, 3000)
        }
    }

    @Watch("validationError.VehicleDetails")
    async validationErrorVehicleDetailsItemsHandler(val: any) {
        if (this.validationError.VehicleDetails == undefined) {
            this.vehicleDetailsItemsLengthError = null;
        }
        else {
            this.vehicleDetailsItemsLengthError = this.validationError.VehicleDetails[0];
            setTimeout(() => {
                this.vehicleDetailsItemsLengthError = null;
            }, 3000)
        }
    }

    @Watch("validationError.Email")
    async validationErrorContactPersonEmailHandler(val: any) {
        if (this.validationError.Email == undefined) {
            this.contactPersonEmailError = null;
        }
        else {
            this.contactPersonEmailError = this.validationError.Email[0];
            setTimeout(() => {
                this.contactPersonEmailError = null;
            }, 3000)
        }
    }

    @Watch("validationError.MailingVehicleTypeId")
    async validationErrorVehicleTypeIdHandler(val: any) {
        if (this.validationError.MailingVehicleTypeId == undefined) {
            this.vehicleTypeIdError = null;
        }
        else {
            this.vehicleTypeIdError = this.validationError.MailingVehicleTypeId[0];
            setTimeout(() => {
                this.vehicleTypeIdError = null;
            }, 3000)
        }
    }

    @Watch("validationError.Quantity")
    async validationErrorVehicleQuantityHandler(val: any) {
        if (this.validationError.Quantity == undefined) {
            this.vehicleQuantityError = null;
        }
        else {
            this.vehicleQuantityError = this.validationError.Quantity[0];
            setTimeout(() => {
                this.vehicleQuantityError = null;
            }, 3000)
        }
    }

    @Watch("validationError.ServedCountries")
    async validationErrorServedCountriesHandler(val: any) {
        if (this.validationError.ServedCountries == undefined) {
            this.servedCountriesError = null;
        }
        else {
            this.servedCountriesError = this.validationError.ServedCountries[0];
            setTimeout(() => {
                this.servedCountriesError = null;
            }, 3000)
        }
    }

    created() {
        this.$store.direct.dispatch.mailing.loadMailingDetails();
    }

    allowNumbersOnly(evt: any) {
        return this.$store.direct.dispatch.settlementCommon.allowNumbersOnly(evt);
    }

    addVehicleRow() {
        if (!this.$store.direct.state.mailing.mailingContractorCarrierFormData) return;
        this.$store.direct.state.mailing.mailingContractorCarrierFormData.vehicleDetails.push({
            id: 0,
            mailingVehicleTypeId: 0,
            quantity: null,
            adr: false,
            lift: false,
            openRoof: false,
            frigo: false,
            additionalInfo: ""
        });
    }

    removeVehicleRow(index: number) {
        if (!this.$store.direct.state.mailing.mailingContractorCarrierFormData) return;
        this.$store.direct.state.mailing.mailingContractorCarrierFormData.vehicleDetails.splice(index, 1);
    }

    addContactPersonRow(): void {
        if (!this.$store.direct.state.mailing.mailingContractorCarrierFormData) return;
        if (!this.mailingFormData.contactPersons) {
            this.mailingFormData.contactPersons = [];
        }
        this.$store.direct.state.mailing.mailingContractorCarrierFormData.contactPersons.push({
            id: 0,
            contractorId: this.contractorCarrierData.id,
            firstName: "",
            lastName: "",
            position: "",
            telephone: "",
            email: ""
        });
    }

    removeContactPersonRow(index: number): void {
        if (!this.$store.direct.state.mailing.mailingContractorCarrierFormData) return;
        this.$store.direct.state.mailing.mailingContractorCarrierFormData.contactPersons.splice(index, 1);
    }

    async onSaveClick() {
        if (!this.contractorCarrierData.isConsented) {
            this.$store.direct.dispatch.confirm
                .openConfirmDialog({
                    showConfirmDialog: true,
                    title: this.$t("mailing.notCheckedIsConsentCheckboxDialogTitle").toString(),
                    message: this.$t("mailing.notCheckedIsConsentCheckboxDialogMessage").toString(),
                    links: [],
                    options: { buttonColor: "error", layoutColor: "red" },
                    buttonType: "yes/no"
                })
                .then(confirm => {
                    if (confirm) {
                        this.$store.direct.dispatch.mailing.saveMailingDetails();
                    }
                });
        }
        else {
            this.$store.direct.dispatch.mailing.saveMailingDetails();
        }
    }
}